// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"be68959a","239":"262ea54f","455":"df0221fc"}[chunkId] + ".chunk.js";
};